module.exports = __webpack_public_path__ + "static/blackgirlscode-174cb6ca6da3b2791abb1b2ac143b848.png";